module.exports = fox._r("images/press/materials-icon-ot.png", __webpack_public_path__ + "_/common/images/press/materials-icon-ot.png");


//////////////////
// WEBPACK FOOTER
// ../common/images/press/materials-icon-ot.png
// module id = 373
// module chunks = 2